import apiService from "./api.service";


class InventoryService {

  async search(entry) {
    const result = await apiService.get('/netsuite/getItems/' + entry)
      .then(function (response) {
        console.log('inventorySearch');
        return response.data;
      })
      .catch(function (error) {
        throw new Error('get inventory error: ' + JSON.stringify(error));
      });

    return result;
  }

  async searchHTS(entry) {
    return apiService.get(`/hts/getAll?htsCode=${entry}`)
      .then(function (response) {
        console.log('HTS search');
        return response.data;
      })
      .catch(function (error) {
        throw new Error('get HTS error: ' + JSON.stringify(error));
      });
  }

  async getHTS(htsCode, rollupDescription, productCode, fda) {
    return apiService.get(`/hts/getAll?htsCode=${htsCode}&rollupDescription=${rollupDescription}&productCode=${productCode}&fda=${fda}`)
      .then(function (response) {
        console.log('HTS search');
        return response.data;
      })
      .catch(function (error) {
        throw new Error('get HTS error: ' + JSON.stringify(error));
      });
  }
}

export default new InventoryService();


// WEBPACK FOOTER //
// ./src/services/inventory.service.js